module.exports = __webpack_public_path__ + "static/media/Pitch.1e7115c8.pdf";